<template>
  <div class="home-page">
    <div class="hero" ref="heroSection">
      <div class="content">
        <div class="avatar-container" ref="avatarContainer">
          <img src="https://wldcloud.cn/img.jpg" alt="个人头像" class="avatar">
        </div>
        <h1 class="title" ref="title">欢迎来到我的空间</h1>
        <p class="subtitle" ref="subtitle">前端开发工程师 / 高艳锋</p>
        <div class="cta-container" ref="ctaContainer">
          <button class="cta-button" @click="scrollToAbout">了解更多</button>
        </div>
      </div>
      <div class="scroll-indicator" ref="scrollIndicator">
        <span class="mouse"></span>
        <span class="scroll-text">向下滚动</span>
      </div>
    </div>
    
    <!-- 个人介绍部分 -->
    <section class="about-section" ref="aboutSection">
      <div class="container">
        <h2 class="section-title" ref="aboutTitle">关于我</h2>
        <div class="about-content">
          <div class="about-text" ref="aboutText">
            <p class="intro">你好！我是一个普普通通的前端开发者</p>
            <div class="experience-block">
              <h3>专业技能</h3>
              <ul>
                <li>
                  <strong>现代前端框架</strong>
                  <p>精通 Vue.js 生态系统，包括 Vue3、Vuex、Vue Router</p>
                </li>
                <li>
                  <strong>跨平台开发</strong>
                  <p>使用 uni-app 开发多端应用，实现一套代码多端运行</p>
                  <!-- <div class="sub-skills">
                    <div class="sub-skill">
                      <i class="fas fa-mobile-alt"></i>
                      <span>原生API集成</span>
                      <p>整合相机、定位、推送等原生功能</p>
                    </div>
                    <div class="sub-skill">
                      <i class="fas fa-layer-group"></i>
                      <span>跨平台适配</span>
                      <p>处理 iOS/Android 平台差异，优化用户体验</p>
                    </div>
                    <div class="sub-skill">
                      <i class="fas fa-rocket"></i>
                      <span>性能优化</span>
                      <p>首屏加载优化、内存管理、离线缓存策略</p>
                    </div>
                  </div> -->
                </li>
                <li>
                  <strong>动画与交互</strong>
                  <p>专注于使用 GSAP 创建流畅的动画效果和交互体验</p>
                </li>
                <li>
                  <strong>3D 可视化</strong>
                  <p>熟练使用 Three.js 构建 3D 场景和交互体验</p>
                </li>
       
                <li>
                  <strong>数据可视化</strong>
                  <p>熟练运用 ECharts 进行数据可视化展示</p>
                </li>
                <li>
                  <strong>实时通信</strong>
                  <p>掌握 WebSocket 实现实时数据传输和即时通讯</p>
                </li>
              </ul>
            </div>
            <div class="experience-block">
              <h3>技术难点攻克</h3>
              <ul>
                <li>
                  <strong>性能优化</strong>
                  <p>优化 Swiper + Video 组合的滑动性能，实现流畅的视频切换体验</p>
                </li>
                <li>
                  <strong>状态管理</strong>
                  <p>设计并实现多层级组件的数据同步方案，确保数据流的可预测性和可维护性</p>
                </li>
                <li>
                  <strong>性能监控</strong>
                  <p>搭建前端性能监控系统，实时跟踪和优化应用性能指标</p>
                </li>
                <li>
                  <strong>表单优化</strong>
                  <p>通过虚拟滚动和延迟校验优化大型表单的渲染性能和验证响应速度</p>
                </li>
                <li>
                  <strong>移动端优化</strong>
                  <p>基于 uni-app 实现 Android/iOS 应用，解决跨平台兼容性问题和性能优化：</p>
                  <ul class="sub-list">
                    <li>优化大型列表渲染，实现流畅滚动和内存管理</li>
                    <li>处理 iOS/Android 平台差异，统一交互体验</li>
                    <li>实现应用更新机制和热更新方案</li>
                    <li>优化应用启动速度和包体积</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div class="skills" ref="skillsContainer">
            <h3>技术熟练度</h3>
            <div class="skill-items">
              <div class="skill-item" v-for="(skill, index) in skills" :key="index" :ref="el => skillRefs[index] = el">
                <div class="skill-header">
                  <div class="skill-icon">
                    <i :class="skill.icon"></i>
                  </div>
                  <h4>{{ skill.name }}</h4>
                </div>
                <div class="skill-info">
                  <div class="skill-bar">
                    <div class="skill-progress" :style="{ width: '0%' }" :data-progress="skill.progress"></div>
                  </div>
                  <p class="skill-description">{{ skill.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 作品集部分 -->
    <section class="portfolio-section" ref="portfolioSection">
      <div class="container">
        <h2 class="section-title" ref="portfolioTitle">学习计划</h2>
        <p class="section-description">这是我规划的前端技术学习路线，展示了对技术发展的理解和持续学习的决心</p>
        <div class="portfolio-grid" ref="portfolioGrid">
          <div 
            v-for="(project, index) in projects" 
            :key="index"
            class="portfolio-item"
            :ref="el => projectRefs[index] = el"
            @mouseenter="onProjectHover(index, true)"
            @mouseleave="onProjectHover(index, false)"
          >
            <div class="project-image">
              <img :src="project.image" :alt="project.title">
              <div class="project-overlay">
                <h3>{{ project.title }}</h3>
                <p>{{ project.description }}</p>
                <div class="project-status">
                  <span class="status-badge" :class="project.status === '进行中' ? 'active' : ''">
                    <i class="fas" :class="getStatusIcon(project.status)"></i>
                    {{ project.status }}
                  </span>
                  <span class="timeline-badge">
                    <i class="fas fa-calendar"></i>
                    {{ project.timeline }}
                  </span>
                </div>
              </div>
            </div>
            <div class="project-info">
              <h4 class="project-title">{{ project.title }}</h4>
              <div class="project-meta">
                <span class="status-badge small" :class="project.status === '进行中' ? 'active' : ''">
                  {{ project.status }}
                </span>
                <span class="timeline-badge small">{{ project.timeline }}</span>
              </div>
              <div class="project-tech">
                <span v-for="tech in project.technologies" :key="tech" class="tech-tag">
                  {{ tech }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术栈部分 -->
    <section class="tech-stack-section" ref="techStackSection">
      <div class="container">
        <h2 class="section-title" ref="techStackTitle">本站技术栈</h2>
        <p class="section-description">基于现代前端技术栈，打造高性能的个人展示网站</p>

        <!-- 性能指标 -->
        <div class="metrics-grid" ref="metricsGrid">
          <div class="metric-card">
            <div class="metric-value">98</div>
            <div class="metric-label">Lighthouse 性能评分</div>
          </div>
          <div class="metric-card">
            <div class="metric-value">&lt; 1s</div>
            <div class="metric-label">首屏加载时间</div>
          </div>
          <div class="metric-card">
            <div class="metric-value">60fps</div>
            <div class="metric-label">动画帧率</div>
          </div>
        </div>

        <!-- 核心技术 -->
        <div class="tech-categories" ref="techCategories">
          <div class="tech-category">
            <h3>核心框架</h3>
            <div class="tech-items">
              <div class="tech-item">
                <i class="fab fa-vuejs"></i>
                <div class="tech-details">
                  <h4>Vue 3</h4>
                  <p>采用 Composition API，实现更好的代码组织和逻辑复用</p>
                  <div class="tech-tags">
                    <span>组件化</span>
                    <span>响应式</span>
                    <span>TypeScript</span>
                  </div>
                </div>
              </div>
              <div class="tech-item">
                <i class="fas fa-bolt"></i>
                <div class="tech-details">
                  <h4>Vite</h4>
                  <p>基于原生 ESM 的构建工具，提供极速的开发体验</p>
                  <div class="tech-tags">
                    <span>快速热更新</span>
                    <span>按需编译</span>
                    <span>优化构建</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tech-category">
            <h3>样式解决方案</h3>
            <div class="tech-items">
              <div class="tech-item">
                <i class="fab fa-sass"></i>
                <div class="tech-details">
                  <h4>SCSS</h4>
                  <p>采用 SCSS 进行样式开发，实现模块化的样式管理</p>
                  <div class="tech-tags">
                    <span>嵌套语法</span>
                    <span>变量系统</span>
                    <span>混入复用</span>
                  </div>
                </div>
              </div>
              <div class="tech-item">
                <i class="fas fa-magic"></i>
                <div class="tech-details">
                  <h4>GSAP</h4>
                  <p>专业的动画库，实现流畅的滚动和交互动画</p>
                  <div class="tech-tags">
                    <span>ScrollTrigger</span>
                    <span>时间轴</span>
                    <span>性能优化</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tech-category">
            <h3>性能优化</h3>
            <div class="tech-items">
              <div class="tech-item">
                <i class="fas fa-rocket"></i>
                <div class="tech-details">
                  <h4>资源优化</h4>
                  <p>采用多项技术手段优化资源加载和执行效率</p>
                  <div class="tech-tags">
                    <span>代码分割</span>
                    <span>懒加载</span>
                    <span>预加载</span>
                  </div>
                </div>
              </div>
              <div class="tech-item">
                <i class="fas fa-tachometer-alt"></i>
                <div class="tech-details">
                  <h4>渲染优化</h4>
                  <p>优化页面渲染性能，提供流畅的用户体验</p>
                  <div class="tech-tags">
                    <span>虚拟列表</span>
                    <span>防抖节流</span>
                    <span>CSS优化</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系方式部分 -->
    <section class="contact-section" ref="contactSection">
      <div class="container">
        <h2 class="section-title" ref="contactTitle">联系我</h2>
        <p class="section-description">如果您对我感兴趣，欢迎通过以下方式联系我</p>

        <div class="contact-grid" ref="contactGrid">
          <div class="contact-card">
            <div class="contact-icon">
              <i class="fas fa-envelope"></i>
            </div>
            <h3>邮箱</h3>
            <p>1431316038@qq.com</p>
            <a href="mailto:1431316038@qq.com" 
               class="contact-link" 
               @click="handleEmailClick"
               title="点击发送邮件（请确保已设置默认邮件客户端）">
              发送邮件
              <i class="fas fa-arrow-right"></i>
            </a>
          </div>

          <div class="contact-card">
            <div class="contact-icon">
              <i class="fab fa-git-alt"></i>
            </div>
            <h3>Gitee</h3>
            <p>gitee.com/gaoyanfengS</p>
            <a href="https://gitee.com/gaoyanfengS" target="_blank" class="contact-link">
              查看项目
              <i class="fas fa-arrow-right"></i>
            </a>
          </div>

          <div class="contact-card">
            <div class="contact-icon">
              <i class="fab fa-weixin"></i>
            </div>
            <h3>微信</h3>
            <p>点击查看二维码</p>
            <a class="contact-link" @click="showQRCode = true">
              查看二维码
              <i class="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>

        <div class="social-links" ref="socialLinks">
          <a href="#" class="social-link" title="掘金">
            <i class="fas fa-book"></i>
          </a>
          <a href="#" class="social-link" title="知乎">
            <i class="fab fa-zhihu"></i>
          </a>
          <a href="#" class="social-link" title="CSDN">
            <i class="fas fa-code"></i>
          </a>
        </div>
      </div>
    </section>

    <!-- 二维码弹窗 -->
    <div class="modal" v-if="showQRCode" @click="showQRCode = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>微信二维码</h3>
          <button class="close-button" @click="showQRCode = false">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <img src="https://wldcloud.cn/wechat.jpg" alt="微信二维码">
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="container">
        <p class="copyright">© 2025 高艳锋的个人作品集</p>
        <p class="rights">保留所有权利 | 本网站内容受知识产权法保护</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'HomePage',
  setup() {
    const heroSection = ref(null)
    const avatarContainer = ref(null)
    const title = ref(null)
    const subtitle = ref(null)
    const ctaContainer = ref(null)
    const scrollIndicator = ref(null)
    
    // 新增的 refs
    const aboutSection = ref(null)
    const aboutTitle = ref(null)
    const aboutText = ref(null)
    const skillsContainer = ref(null)
    const skillRefs = ref([])

    const portfolioSection = ref(null)
    const portfolioTitle = ref(null)
    const portfolioGrid = ref(null)
    const projectRefs = ref([])

    const techStackSection = ref(null)
    const techStackTitle = ref(null)
    const metricsGrid = ref(null)
    const techCategories = ref(null)

    const contactSection = ref(null)
    const contactTitle = ref(null)
    const contactGrid = ref(null)
    const socialLinks = ref(null)

    const showQRCode = ref(false)

    const skills = [
      { 
        name: 'Vue.js', 
        progress: '95', 
        icon: 'fab fa-vuejs',
        description: '深入理解Vue3生态系统，包括Composition API、状态管理和性能优化'
      },
      { 
        name: 'uni-app', 
        progress: '94', 
        icon: 'fas fa-mobile-alt',
        description: '跨平台应用开发专家，擅长处理多端适配和原生功能集成'
      },
      { 
        name: 'GSAP', 
        progress: '80', 
        icon: 'fas fa-magic',
        description: '精通高性能动画创建，包括ScrollTrigger和复杂时间轴动画设计'
      },
      { 
        name: 'Three.js', 
        progress: '80', 
        icon: 'fas fa-cube',
        description: '专注于创建高性能3D可视化场景，具备复杂模型优化和交互设计经验'
      },
      { 
        name: 'ECharts', 
        progress: '90', 
        icon: 'fas fa-chart-line',
        description: '数据可视化专家，擅长大规模数据展示和自定义图表开发'
      },
      { 
        name: 'WebSocket', 
        progress: '85', 
        icon: 'fas fa-plug',
        description: '实时通信专家，具备高并发处理和实时数据同步经验'
      }
    ]

    const projects = [
      {
        title: '前端工程化实践',
        description: '计划深入学习 Webpack、Vite 等构建工具，掌握模块化、打包优化、开发效率提升等核心技能',
        image: 'https://picsum.photos/600/400?random=1',
        status: '持续进行',
        timeline: '2022 Q2',
        technologies: ['Webpack', 'Vite', 'Babel', 'ESLint']
      },
      {
        title: '性能优化专题',
        description: '系统学习前端性能优化技术，包括加载优化、运行时优化、框架层面优化等，并在实践中应用',
        image: 'https://picsum.photos/600/400?random=2',
        status: '持续进行',
        timeline: '2024 Q2-Q3',
        technologies: ['性能监控', '资源优化', 'CDN', 'PWA']
      },
      {
        title: '跨端开发进阶',
        description: '深入研究跨端开发技术，掌握多端适配方案、原生功能集成、性能优化等进阶知识',
        image: 'https://picsum.photos/600/400?random=3',
        status: '持续进行',
        timeline: '2022 Q3',
        technologies: ['uni-app', 'Flutter', 'React Native']
      },
      {
        title: '前沿技术探索',
        description: '持续关注和学习前端新技术，包括微前端、Web Assembly、AI 集成等创新领域',
        image: 'https://picsum.photos/600/400?random=4',
        status: '持续进行',
        timeline: '2025-???',
        technologies: ['微前端', 'WebAssembly', 'AI 集成']
      }
    ]

    const onProjectHover = (index, isEnter) => {
      const project = projectRefs.value[index]
      const overlay = project.querySelector('.project-overlay')
      const image = project.querySelector('img')

      if (isEnter) {
        gsap.to(overlay, {
          opacity: 1,
          duration: 0.3,
          ease: 'power2.out'
        })
        gsap.to(image, {
          scale: 1.1,
          duration: 0.5,
          ease: 'power2.out'
        })
      } else {
        gsap.to(overlay, {
          opacity: 0,
          duration: 0.3,
          ease: 'power2.out'
        })
        gsap.to(image, {
          scale: 1,
          duration: 0.5,
          ease: 'power2.out'
        })
      }
    }

    const getStatusIcon = (status) => {
      switch (status) {
        case '进行中':
          return 'fa-spinner fa-spin'
        case '规划中':
          return 'fa-clipboard-list'
        case '计划中':
          return 'fa-calendar-alt'
        case '持续进行':
          return 'fa-sync-alt'
        default:
          return 'fa-info-circle'
      }
    }

    const scrollToAbout = () => {
      aboutSection.value.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      })
    }

    const handleEmailClick = () => {
      const email = '1431316038@qq.com';
      
      // 创建临时输入框
      const textArea = document.createElement('textarea');
      textArea.value = email;
      document.body.appendChild(textArea);
      
      try {
        // 选择文本
        textArea.select();
        // 执行复制命令
        document.execCommand('copy');
        alert('邮箱地址已复制到剪贴板！\n如果邮件客户端没有打开，您可以手动打开邮件客户端并粘贴地址。');
      } catch (err) {
        alert('请手动复制邮箱地址：' + email);
      } finally {
        // 移除临时输入框
        document.body.removeChild(textArea);
      }
    }

    onMounted(() => {
      // 原有的动画
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })
      
      tl.from(avatarContainer.value, {
        scale: 0,
        opacity: 0,
        duration: 1,
        ease: 'back.out(1.7)'
      })
      .from(title.value, {
        y: 100,
        opacity: 0,
        duration: 1.2
      }, '-=0.5')
      .from(subtitle.value, {
        y: 50,
        opacity: 0,
        duration: 1
      }, '-=0.8')
      .from(ctaContainer.value, {
        y: 30,
        opacity: 0,
        duration: 0.8
      }, '-=0.6')
      .from(scrollIndicator.value, {
        opacity: 0,
        duration: 0.8
      }, '-=0.4')

      // 添加鼠标悬停效果
      const ctaButton = ctaContainer.value.querySelector('.cta-button')
      ctaButton.addEventListener('mouseenter', () => {
        gsap.to(ctaButton, {
          scale: 1.05,
          duration: 0.3
        })
      })
      
      ctaButton.addEventListener('mouseleave', () => {
        gsap.to(ctaButton, {
          scale: 1,
          duration: 0.3
        })
      })

      // 滚动触发动画
      gsap.from(aboutTitle.value, {
        scrollTrigger: {
          trigger: aboutTitle.value,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        y: 50,
        opacity: 0,
        duration: 1
      })

      gsap.from(aboutText.value.children, {
        scrollTrigger: {
          trigger: aboutText.value,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        },
        y: 30,
        opacity: 0,
        duration: 0.8,
        stagger: 0.2
      })

      // 技能条动画
      skillRefs.value.forEach((skill, index) => {
        const progress = skill.querySelector('.skill-progress')
        const targetProgress = progress.getAttribute('data-progress')

        gsap.to(progress, {
          scrollTrigger: {
            trigger: skill,
            start: 'top 80%',
            toggleActions: 'play none none reverse'
          },
          width: targetProgress + '%',
          duration: 1.5,
          ease: 'power2.out'
        })

        gsap.from(skill, {
          scrollTrigger: {
            trigger: skill,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          },
          y: 30,
          opacity: 0,
          duration: 0.6,
          delay: index * 0.1
        })
      })

      // 作品集动画
      gsap.from(portfolioTitle.value, {
        scrollTrigger: {
          trigger: portfolioTitle.value,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        y: 50,
        opacity: 0,
        duration: 1
      })

      projectRefs.value.forEach((project, index) => {
        gsap.from(project, {
          scrollTrigger: {
            trigger: project,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          },
          y: 50,
          opacity: 0,
          duration: 0.8,
          delay: index * 0.2
        })
      })

      // 技术栈动画
      gsap.from(techStackTitle.value, {
        scrollTrigger: {
          trigger: techStackTitle.value,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        y: 50,
        opacity: 0,
        duration: 1
      })

      gsap.from(metricsGrid.value.children, {
        scrollTrigger: {
          trigger: metricsGrid.value,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        },
        y: 30,
        opacity: 0,
        duration: 0.8,
        stagger: 0.2
      })

      gsap.from(techCategories.value.children, {
        scrollTrigger: {
          trigger: techCategories.value,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        },
        y: 30,
        opacity: 0,
        duration: 0.8,
        stagger: 0.2
      })

      // 联系方式动画
      gsap.from(contactTitle.value, {
        scrollTrigger: {
          trigger: contactTitle.value,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        y: 50,
        opacity: 0,
        duration: 1
      })

      gsap.from(contactGrid.value.children, {
        scrollTrigger: {
          trigger: contactGrid.value,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        },
        y: 30,
        opacity: 0,
        duration: 0.8,
        stagger: 0.2
      })

      gsap.from(socialLinks.value.children, {
        scrollTrigger: {
          trigger: socialLinks.value,
          start: 'top 85%',
          toggleActions: 'play none none reverse'
        },
        scale: 0,
        opacity: 0,
        duration: 0.6,
        stagger: 0.1
      })
    })

    return {
      heroSection,
      avatarContainer,
      title,
      subtitle,
      ctaContainer,
      scrollIndicator,
      aboutSection,
      aboutTitle,
      aboutText,
      skillsContainer,
      skillRefs,
      skills,
      portfolioSection,
      portfolioTitle,
      portfolioGrid,
      projectRefs,
      projects,
      onProjectHover,
      getStatusIcon,
      techStackSection,
      techStackTitle,
      metricsGrid,
      techCategories,
      contactSection,
      contactTitle,
      contactGrid,
      socialLinks,
      showQRCode,
      scrollToAbout,
      handleEmailClick,
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  color: #ffffff;
}

.hero {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0 20px;
}

.content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.title {
  font-size: clamp(2.5rem, 8vw, 4.5rem);
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: clamp(1.2rem, 4vw, 1.8rem);
  opacity: 0.8;
  margin-bottom: 2rem;
}

.cta-button {
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  color: white;
  border-radius: 30px;
  cursor: pointer;
  transition: transform 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-2px);
  }
}

.scroll-indicator {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.mouse {
  width: 30px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  position: relative;

  &::before {
    content: '';
    width: 4px;
    height: 8px;
    background: white;
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
    animation: scroll 1.5s infinite;
  }
}

.scroll-text {
  font-size: 0.9rem;
  opacity: 0.8;
}

@keyframes scroll {
  0% {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, 20px);
    opacity: 0;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .hero {
    padding: 0 15px;
  }

  .cta-button {
    padding: 0.8rem 2rem;
    font-size: 1rem;
  }
}

.about-section {
  min-height: 100vh;
  background: #1a1a1a;
  padding: 100px 0;
  color: #ffffff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: clamp(2rem, 5vw, 3rem);
  text-align: center;
  margin-bottom: 60px;
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: start;
}

.about-text {
  .intro {
    font-size: 1.4rem;
    font-weight: 500;
    margin-bottom: 2rem;
    color: #4ecdc4;
  }

  .experience-block {
    margin-bottom: 2.5rem;

    h3 {
      font-size: 1.3rem;
      color: #ff6b6b;
      margin-bottom: 1.2rem;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 1.5rem;
        padding-left: 1rem;
        border-left: 3px solid rgba(78, 205, 196, 0.3);

        &:hover {
          border-left-color: #4ecdc4;
        }

        strong {
          display: block;
          color: #ffffff;
          font-size: 1.1rem;
          margin-bottom: 0.5rem;
        }

        p {
          font-size: 1rem;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.8);
          margin: 0;
        }
      }
    }
  }
}

.skills {
  background: rgba(255, 255, 255, 0.05);
  padding: 2.5rem;
  border-radius: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 40px;
  h3 {
    font-size: 1.5rem;
    margin-bottom: 30px;
    color: #4ecdc4;
    text-align: center;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
      border-radius: 2px;
    }
  }
}

.skill-items {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.skill-item {
  background: rgba(255, 255, 255, 0.03);
  padding: 20px;
  border-radius: 12px;
  transition: transform 0.3s ease, background-color 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);

  &:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.05);
  }
}

.skill-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;

  h4 {
    margin: 0;
    font-size: 1.2rem;
    color: #ffffff;
  }
}

.skill-icon {
  font-size: 1.8rem;
  color: #ff6b6b;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 10px;
}

.skill-info {
  .skill-bar {
    height: 8px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 12px;
  }

  .skill-progress {
    height: 100%;
    background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
    border-radius: 4px;
    width: 0;
  }

  .skill-description {
    font-size: 0.95rem;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
    padding-left: 5px;
  }
}

@media (max-width: 768px) {
  .about-section {
    padding: 60px 0;
  }

  .about-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .about-text p {
    font-size: 1.1rem;
  }

  .skill-icon {
    font-size: 1.5rem;
    width: 40px;
  }

  .skills {
    padding: 1.5rem;
  }

  .skill-item {
    padding: 15px;
  }

  .skill-icon {
    font-size: 1.5rem;
    width: 35px;
    height: 35px;
  }

  .skill-header h4 {
    font-size: 1.1rem;
  }

  .skill-description {
    font-size: 0.9rem;
  }
}

.portfolio-section {
  min-height: 100vh;
  background: #1a1a1a;
  padding: 100px 0;
  color: #ffffff;
}

.portfolio-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  padding: 30px 0;
}

.portfolio-item {
  border-radius: 12px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(78, 205, 196, 0.3);
  }
}

.project-image {
  position: relative;
  overflow: hidden;
  aspect-ratio: 16/10;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
}

.project-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(26, 26, 26, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  opacity: 0;
  text-align: center;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 10px;
    color: #4ecdc4;
  }

  p {
    font-size: 1rem;
    margin-bottom: 20px;
    line-height: 1.6;
  }
}

.project-links {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.project-link {
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  
  i {
    margin-right: 5px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
}

.demo-link {
  background: linear-gradient(45deg, #4ecdc4, #2fb344);
}

.code-link {
  background: linear-gradient(45deg, #ff6b6b, #ff8e53);
}

.project-info {
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
}

.project-tech {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tech-tag {
  background: rgba(78, 205, 196, 0.1);
  color: #4ecdc4;
  padding: 4px 10px;
  border-radius: 15px;
  font-size: 0.8rem;
}

.project-title {
  font-size: 1.2rem;
  color: #ffffff;
  margin: 0 0 10px;
}

.project-meta {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;

  &.active {
    background: rgba(78, 205, 196, 0.2);
    color: #4ecdc4;
  }

  &.small {
    padding: 4px 8px;
    font-size: 0.8rem;
  }

  i {
    font-size: 0.8rem;
  }
}

.timeline-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  background: rgba(255, 107, 107, 0.1);
  color: #ff6b6b;

  &.small {
    padding: 4px 8px;
    font-size: 0.8rem;
  }

  i {
    font-size: 0.8rem;
  }
}

.project-status {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

@media (max-width: 768px) {
  .portfolio-section {
    padding: 60px 0;
  }

  .portfolio-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .project-overlay {
    h3 {
      font-size: 1.3rem;
    }

    p {
      font-size: 0.9rem;
    }
  }

  .section-description {
    font-size: 1rem;
    margin-bottom: 30px;
  }

  .project-title {
    font-size: 1.1rem;
  }

  .project-link {
    padding: 8px 15px;
    font-size: 0.85rem;
  }

  .status-badge, .timeline-badge {
    padding: 4px 8px;
    font-size: 0.8rem;
  }
}

.sub-skills {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
}

.sub-skill {
  padding: 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.08);
  }

  i {
    color: #4ecdc4;
    font-size: 1.2rem;
    margin-bottom: 8px;
  }

  span {
    display: block;
    color: #ff6b6b;
    font-size: 0.95rem;
    font-weight: 500;
    margin: 8px 0;
  }

  p {
    font-size: 0.9rem !important;
    opacity: 0.8;
    margin: 0 !important;
  }
}

.sub-list {
  list-style: none;
  padding-left: 20px;
  margin-top: 10px;

  li {
    position: relative;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 8px;
    padding-left: 15px;

    &::before {
      content: '•';
      position: absolute;
      left: 0;
      color: #4ecdc4;
    }
  }
}

@media (max-width: 768px) {
  .sub-skills {
    grid-template-columns: 1fr;
  }

  .sub-skill {
    padding: 10px;

    span {
      font-size: 0.9rem;
    }

    p {
      font-size: 0.85rem !important;
    }
  }

  .sub-list li {
    font-size: 0.85rem;
  }
}

.tech-stack-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  // margin: 50px 0;
}

.metric-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 25px;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.08);
  }

  .metric-value {
    font-size: 2.5rem;
    font-weight: 700;
    background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 10px;
  }

  .metric-label {
    color: rgba(255, 255, 255, 0.8);
    font-size: 1rem;
  }
}

.tech-categories {
  display: grid;
  gap: 50px;
  margin-top: 50px;
}

.tech-category {
  h3 {
    font-size: 1.8rem;
    margin-bottom: 30px;
    color: #4ecdc4;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 0;
      width: 60px;
      height: 3px;
      background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
      border-radius: 2px;
    }
  }
}

.tech-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.tech-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 25px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.08);
  }

  i {
    font-size: 2rem;
    color: #ff6b6b;
    background: rgba(255, 107, 107, 0.1);
    padding: 15px;
    border-radius: 12px;
  }

  .tech-details {
    flex: 1;

    h4 {
      font-size: 1.3rem;
      color: #ffffff;
      margin-bottom: 10px;
    }

    p {
      font-size: 0.95rem;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 15px;
      line-height: 1.6;
    }
  }

  .tech-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    span {
      font-size: 0.85rem;
      padding: 4px 12px;
      background: rgba(78, 205, 196, 0.1);
      color: #4ecdc4;
      border-radius: 20px;
    }
  }
}

@media (max-width: 768px) {
  .tech-stack-section {
    padding: 60px 0;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
    gap: 20px;
    margin: 30px 0;
  }

  .metric-card {
    padding: 20px;

    .metric-value {
      font-size: 2rem;
    }

    .metric-label {
      font-size: 0.9rem;
    }
  }

  .tech-category {
    h3 {
      font-size: 1.5rem;
      margin-bottom: 25px;
    }
  }

  .tech-items {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .tech-item {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;

    i {
      font-size: 1.5rem;
      padding: 12px;
    }

    .tech-details {
      h4 {
        font-size: 1.2rem;
      }

      p {
        font-size: 0.9rem;
      }
    }

    .tech-tags span {
      font-size: 0.8rem;
      padding: 3px 10px;
    }
  }
}

.contact-section {
  padding: 100px 0;
  background: #1a1a1a;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  // margin: 50px 0;
}

.contact-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.08);
  }

  .contact-icon {
    width: 60px;
    height: 60px;
    margin: 0 auto 20px;
    background: rgba(255, 107, 107, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 1.8rem;
      color: #ff6b6b;
    }
  }

  h3 {
    font-size: 1.4rem;
    color: #ffffff;
    margin-bottom: 10px;
  }

  p {
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 20px;
  }

  .contact-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #4ecdc4;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
      color: #ff6b6b;
      gap: 12px;
    }

    i {
      font-size: 0.9rem;
    }
  }

  .qr-code {
    max-width: 150px;
    margin: 0 auto;
    
    img {
      width: 100%;
      height: auto;
      border-radius: 8px;
    }
  }
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 50px;
}

.social-link {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 107, 107, 0.2);
    color: #ff6b6b;
    transform: translateY(-3px);
  }

  i {
    font-size: 1.3rem;
  }
}

.footer {
  padding: 30px 0;
  background: rgba(0, 0, 0, 0.3);
  text-align: center;

  .container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .copyright {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.95rem;
    margin: 0;
  }

  .rights {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.85rem;
    margin: 0;
  }
}

@media (max-width: 768px) {
  .contact-section {
    padding: 60px 0;
  }

  .contact-grid {
    gap: 20px;
    margin: 30px 0;
  }

  .contact-card {
    padding: 25px;

    .contact-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 15px;

      i {
        font-size: 1.5rem;
      }
    }

    h3 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.9rem;
    }
  }

  .social-links {
    gap: 15px;
    margin-top: 30px;
  }

  .social-link {
    width: 40px;
    height: 40px;

    i {
      font-size: 1.1rem;
    }
  }

  .footer {
    padding: 20px 0;
    
    .copyright {
      font-size: 0.85rem;
    }
    
    .rights {
      font-size: 0.75rem;
    }
  }
}

/* 弹窗样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.modal-content {
  background: #1a1a1a;
  border-radius: 15px;
  padding: 20px;
  max-width: 90%;
  width: 400px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  h3 {
    margin: 0;
    color: #4ecdc4;
  }
}

.close-button {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  font-size: 1.2rem;
  padding: 5px;
  transition: color 0.3s ease;

  &:hover {
    color: #ff6b6b;
  }
}

.modal-body {
  text-align: center;

  img {
    max-width: 100%;
    border-radius: 8px;
  }
}

@media (max-width: 768px) {
  .modal-content {
    width: 320px;
    margin: 0 20px;
  }
}

.avatar-container {
  width: 150px;
  height: 150px;
  margin: 0 auto 2rem;
  border-radius: 50%;
  padding: 5px;
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border-radius: 50%;
    background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
    opacity: 0.5;
    filter: blur(8px);
    z-index: -1;
  }
}

.avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #1a1a1a;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
}
</style> 